import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M15 5V3H7v2h3L8 15H5v2h8v-2h-3l2-10z'],
  height: 20,
  width: 20,
});
